import zhCN from './json/topic.zh_CN.json';
import zhTW from './json/topic.zh_TW.json';
import en from './json/topic.en.json';
import ja from './json/topic.ja.json';
import ko from './json/topic.ko.json';
import ru from './json/topic.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
